module.exports = __webpack_public_path__ + "static/img/3361_phase_function_Paper_PointsHejduk_Prediction.57ed366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3361_phase_function_Paper_PointsHejduk_Prediction.png
// module id = aBzy
// module chunks = 0